<template>
  <div id="hype-video">
    <Button
      v-if="$store.state.repId == '23'"
      text="MIRA VIDEO SORPRENDENTE"
      @click="playVideo"
      link="#video"
    />
    <Button v-else text="Watch Hype Video" @click="playVideo" link="#video" />
  </div>
  <transition name="fade" appear>
    <Video
      ref="player"
      v-show="showVideo"
      @onEnded="onEnded"
    />
  </transition>

  <div id="benefits">
    <img :src="require(`@/assets/images/${titleImage}`)" alt="" />
    <div class="benefits">
      <div v-for="benefit in benefits">
        <img :src="require(`@/assets/icons/benefits/${benefit.icon}`)" alt="" />
        <span>{{ benefit.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "@/components/Button";
import Video from "@/components/Video";
export default {
  name: "IntroSections",
  components: {
    Button,
    Video,
  },
  data() {
    return {
      showVideo: false,
    };
  },

  methods: {
    onEnded() {
      this.showVideo = false;
      window.location.hash = "#calendar";
    },
    playVideo() {
      this.showVideo = true;
      this.$refs.player.playVideo();
    },
  },
  computed: {
    titleImage() {
      if (this.$store.state.repId == 23) {
        return 'title-es.png';
      }
      return 'title.png';
    },
    benefits() {
      if (this.$store.state.repId == 23) {
        return [
          { label: "20% de descuento en mercancia", icon: "icon-bag.svg" },
          {
            label: " Hasta un 15% de descuento en abonos de temporada",
            icon: "icon-ticket.svg",
          },
          { label: "Planes de Pago Flexibles", icon: "icon-cal.svg" },
          {
            label: "Acceso garantizado a los partidos en casa",
            icon: "icon-ball.svg",
          },
          {
            label: "MLS Season Pass en Apple TV iniciando en el 2025",
            icon: "icon-tv.svg",
          },
          {
            label: "Invitaciones a eventos exclusivos del Club",
            icon: "icon-cal-star.svg",
          },
          { label: "Happy Hour para Socios", icon: "icon-beer.svg" },
          {
            label: "Representantes de Servicio",
            icon: "icon-headphone.svg",
          },
        ];
      } else {
        return [
          { label: "20% Merchandise Discount", icon: "icon-bag.svg" },
          {
            label: "15% Discount of single-match pricing",
            icon: "icon-ticket.svg",
          },
          { label: "Interest-Free Payment Plans", icon: "icon-cal.svg" },
          { label: "Guaranteed Access to Home Matches", icon: "icon-ball.svg" },
          {
            label: "MLS Season Pass on  Apple TV beginning 2025",
            icon: "icon-tv.svg",
          },
          { label: "Invites to Exclusive Events", icon: "icon-cal-star.svg" },
          { label: "Season Ticket Member Happy Hour", icon: "icon-beer.svg" },
          {
            label: "Membership Service Representative",
            icon: "icon-headphone.svg",
          },
        ];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#hype-video {
  background: url("~@/assets/images/bg-video-bar.jpg");
  background-size: cover;
  background-position: center;
  padding: 5.25rem 1rem;
}
.hype-video {
  background: url("~@/assets/images/bg-video-bar.jpg");
  background-size: cover;
  background-position: center;
  //max-height: 100dvh;
  #video {
    //height:100%;
    //max-height: 100dvh;
    :deep(iframe) {
      max-height: 100dvh;
    }
    :deep(> div) {
      //height:100%;
      //padding: 0!important;
      //max-height: 100dvh;
    }
  }
}
#benefits {
  background: url("~@/assets/images/bg-benefits.jpg");
  background-size: cover;
  background-position: center bottom;
  padding: 5.25rem 1rem;
  > img {
    max-width: 35.25rem;
    width: 80vw;
  }
  .benefits {
    display: flex;
    gap: 1.25rem;
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;
    max-width: 57.25rem;
    margin: 0 auto;
    margin-top: 2.8rem;
    > div {
      border-radius: 0.625rem;
      border: 3px solid #6d7a7c;
      color: #fff;
      font-family: "Modern Era";
      font-size: 0.8125rem;
      font-weight: 400;
      line-height: 1.07;
      height: 4rem;
      padding: 0 1rem;
      width: 18.125rem;
      display: flex;
      align-items: center;
      gap: 0.63rem;
      flex-grow: 0;
      flex-shrink: 0;
      box-sizing: border-box;
    }
  }
}
</style>